export type Project = {
  id: number;
  name: string;
  description?: string;
  /** This is the guid of the source that will be restored as a new cart */
  guid: string;
  count: number;
  updated_at: string;
  last_ordered_at: string | null;
  thumbnail_url: string;
};

export type ProjectSaveParams = {
  guid?: string;
  id?: number;
  name: string;
  description?: string;
};
